module.exports = __webpack_public_path__ + "img/logo.b37ccb12.png";